import React from 'react';
import tutorialVideo from 'assets/video/bafancy-video-tutorial.mp4';
import indicator from 'assets/images/indicator.png';
import thumb from 'assets/images/Thumbnail.png';

const VideoPlayer = () => {
  return (
    <section className="mx-auto mt-36 px-6 md:mt-0">
      <div className="relative">
        <img src={indicator} className="w-[200px] absolute -top-28 right-10" />
        <video className="cursor-pointer" poster={thumb} controls muted={false}>
          <source src={tutorialVideo} />
        </video>
      </div>
    </section>
  );
};

export default VideoPlayer;
